import React, { useState } from 'react';
import { Phone, Calendar, ChevronDown, ChevronUp, Trash2, MessageSquare } from 'lucide-react';

function MessageList({ messages = [], onDelete }) {
  const [expandedId, setExpandedId] = useState(null);

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('tr-TR', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  if (messages.length === 0) {
    return (
      <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-8 text-center">
        <MessageSquare className="w-10 h-10 text-zinc-700 mx-auto mb-3" />
        <p className="text-zinc-500 text-sm">Henüz mesaj yok</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {messages.map((message) => (
        <div key={message.id} className="bg-zinc-900 border border-zinc-800 rounded-lg overflow-hidden hover:border-zinc-700 transition-colors">
          <div className="p-4">
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 rounded-full bg-violet-600/20 flex items-center justify-center text-violet-400 text-xs font-medium flex-shrink-0">
                    {message.name?.charAt(0)?.toUpperCase() || '?'}
                  </div>
                  <div className="min-w-0">
                    <p className="text-white text-sm font-medium truncate">{message.name} {message.surname}</p>
                    <p className="text-zinc-500 text-xs truncate">{message.email}</p>
                  </div>
                </div>
                
                <div className="flex flex-wrap gap-3 text-xs text-zinc-500 mb-2">
                  {message.phone && (
                    <span className="flex items-center gap-1"><Phone className="w-3 h-3" /> {message.phone}</span>
                  )}
                  <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {formatDate(message.date || message.createdAt)}</span>
                </div>

                <p className={`text-zinc-400 text-sm ${expandedId === message.id ? '' : 'line-clamp-2'}`}>{message.message}</p>
                
                {message.message?.length > 100 && (
                  <button onClick={() => setExpandedId(expandedId === message.id ? null : message.id)} className="flex items-center gap-1 text-violet-400 text-xs mt-2 hover:text-violet-300 transition-colors">
                    {expandedId === message.id ? <><ChevronUp className="w-3 h-3" /> Küçült</> : <><ChevronDown className="w-3 h-3" /> Devamı</>}
                  </button>
                )}
              </div>

              <button onClick={() => onDelete && onDelete(message.id)} className="p-2 text-zinc-500 hover:text-red-400 hover:bg-red-500/10 rounded-lg transition-colors flex-shrink-0" title="Sil">
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default MessageList;
